import { ProjectBase } from './base-classes/project-base'
import { auth } from './auth.module'

const projectBase = new ProjectBase()

projectBase.state.all.defaultFilter = {
  showAll: false,
  projectCode: '',
  projectOwnerUserInitials: auth.state.user.initials,
  projectReviewerUserInitials: '',
  tags: [],
  orderByColumn: 'projectCode',
  orderByDescending: true
}

const mutations = projectBase.mutations()

mutations.resetFilter = (state) => {
  state.all.currentPage = 1
  state.all.defaultFilter.projectOwnerUserInitials = auth.state.user.initials
  state.all.filter = Object.assign({}, state.all.defaultFilter)
}

// const actions = projectBase.actions()
// actions.getListData = () => {
//   console.log('THIS SHOULD BE THE FIRST REQUEST, AND THE CORRECT ONE')
//   console.trace()
// }

export const projectsOwner = {
  namespaced: true,
  state: projectBase.state,
  actions: projectBase.actions(),
  mutations,
  getters: projectBase.getters()
}



// WEBPACK FOOTER //
// ./src/store/project-owner.module.js